const caseGeneratorEnglish = {
  header: {
    title: "Case Post Generator",
    description: "Let AI help you create an engaging LinkedIn post based on your case"
  },
  customerBanner: {
    working: "You are now generating a case post for"
  },
  input: {
    title: "Describe your case",
    placeholder: "Tell us about your case or story. It could be a customer case, an interesting meeting, or another experience you'd like to share on LinkedIn..."
  },
  image: {
    title: "Would you like to add an image?",
    gallery: "Choose from image archive",
    upload: "Upload image",
    camera: "Take photo",
    remove: "Remove image"
  },
  buttons: {
    generate: "Generate post from case",
    generating: "Generating post...",
    retry: "Try again",
    edit: "Edit",
    remove: "Remove image",
    addImage: "Image",
    save: "Save changes",
    saving: "Saving",
    cancel: "Cancel",
    accept: "Accept",
    fortryd: "Discard",
    scheduling: "Scheduling...",
    schedulePost: "Schedule post"
  },
  aiPrompt: {
    placeholder: "Describe how the case post should be improved...",
    editing: "Editing",
    send: "Send"
  },
  loading: {
    generating: "Generating a LinkedIn post based on your case..."
  },
  messages: {
    error: "An error occurred while generating the case post. Please try again later.",
    draftLoaded: "Your latest case draft has been loaded",
    fieldRequired: "Please enter a case description to generate a post",
    imageAdded: "Image added!",
    imageRemoved: "Image removed!",
    caseGenerated: "Case post generated!",
    savedChanges: "Changes saved!",
    caseUpdated: "Case post updated!",
    imageUploaded: "Image uploaded and added!",
    caseScheduled: "Case post scheduled for {formattedDate}",
    aiSelectedTime: "AI has selected the optimal time!",
    confirmDiscard: "Are you sure you want to discard this post? All changes will be lost.",
    caseRegenerated: "Case post regenerated!"
  },
  gallery: {
    title: "Select an image",
    noImages: "You have no images in your archive.",
    goToArchive: "Go to image archive"
  },
  saveModal: {
    title: "Schedule your case post",
    question: "How would you like to schedule your case post?",
    options: {
      weekly: {
        title: "Use my weekly schedule",
        description: "The post will be shared according to your normal scheduling"
      },
      custom: {
        title: "Choose your own time",
        description: "Select exactly when the post should be shared"
      },
      ai: {
        title: "Let AI schedule",
        description: "AI selects the optimal time based on LinkedIn statistics"
      }
    },
    weekly: {
      confirm: "Your post will be added to your normal scheduling and shared according to your weekly plan."
    },
    custom: {
      title: "Select date and time for your post:"
    },
    buttons: {
      back: "Back",
      confirm: "Confirm",
      saving: "Saving..."
    },
    success: {
      weekly: "Your case post has been saved and scheduled for sharing on LinkedIn!",
      custom: "Your case post has been scheduled for sharing on LinkedIn on {date}!",
      ai: "Your case post has been scheduled for sharing on LinkedIn on {date}!"
    }
  },
  weekCalendar: {
    selectDay: "Select day for your post",
    selectTime: "Select time for {day}",
    addPost: "Add post",
    backToDays: "Back to days",
    schedulerNote: "These times are configured in your Scheduler but not yet occupied by existing posts."
  }
};

export default caseGeneratorEnglish; 